import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const PricingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 500px;
  position: relative;
  background-color: #cccccc;
  border-radius: 8px;
  padding: 30px 25px;
  box-shadow: rgb(220, 220, 220) 0px 0px 15px;

  ${mediaMaxWidth.mediumDesktop} {
    width: 650px;
    margin-top: 20px;
  }

  ${mediaMaxWidth.smallDesktop} {
  }

  ${mediaMaxWidth.tablet} {
    margin-top: 10px;
    width: calc(100vw - 20px);
  }
`;

export const PricingTitle = styled.h2`
  display: flex;
  justify-content: center;
  padding: 0 0 20px 0;
  width: 100%;
  align-items: center;
  font-size: 1.3em;
  font-family: "Raleway", sans-serif;
  font-weight: 900;
  color: #4f4f4f;

  ${mediaMaxWidth.tablet} {
    width: 400px;
    margin: 0 auto;
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 80px);
  }
`;

export const PricingOptions = styled.div``;

interface IOptionProps {
  noBorder?: boolean;
}

export const PricingOption = styled.div`
  display: flex;
  border-bottom: ${(props: IOptionProps) =>
    !props.noBorder && "1px solid #858585"};
  height: 52px;
  align-items: center;
  padding: 0 40px;
  color: #444;

  ${mediaMaxWidth.mediumDesktop} {
    flex-direction: column;
    justify-content: center;
    height: 75px;
  }

  ${mediaMaxWidth.tablet} {
    width: 400px;
    margin: 0 auto;
    padding: 0;
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 80px);
  }
`;

export const Price = styled.div`
  font-family: "Raleway", sans-serif;
  font-weight: 900;
  width: 100px;
  color: #333;

  ${mediaMaxWidth.mediumDesktop} {
    width: unset;
  }
`;

export const PriceDescription = styled.div`
  ${mediaMaxWidth.mediumDesktop} {
    font-size: 0.9em;
  }

  ${mediaMaxWidth.tablet} {
    font-size: 0.8em;
  }
`;

export const CallInstructions = styled.div`
  margin: 30px auto 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mediaMaxWidth.tablet} {
    margin: 40px 0 30px 0;
  }
`;

export const CallText = styled.div`
  color: #4f4f4f;
  font-family: "Raleway", sans-serif;
  font-weight: 900;
  padding: 10px;
  font-size: 1.3em;
  text-align: center;
  max-width: 270px;
  border-radius: 8px;
  border: 1px solid #f2008c;

  ${mediaMaxWidth.phone} {
    width: 270px;
    text-align: center;
  }
`;

export const CallButtonLink = styled.a`
  text-align: center;
  color: #4f4f4f !important;
  font-family: "Raleway", sans-serif;
  font-weight: 900 !important;

  &:hover {
    color: #333 !important;
  }

  ${mediaMaxWidth.smallPhone} {
    font-size: 0.9em;
  }
`;
